export default "__VITE_ASSET__DjAP47yH__"